import React, { useState, useEffect } from "react";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
export const ConnectivityStrength = () => {
  const [connectivityStatus, setConnectivityStatus] = useState("Checking...");
  const [networkSpeed, setNetworkSpeed] = useState("Checking...");
  const [statusIcon, setStatusIcon] = useState(<WifiIcon />);

  useEffect(() => {
    const updateConnectivityStatus = () => {
      if (navigator.onLine) {
        const connection =
          navigator.connection ||
          navigator.mozConnection ||
          navigator.webkitConnection;

        if (connection) {
          const effectiveType = connection.effectiveType;
          const downlinkMbps = connection.downlink;

          if (effectiveType) {
            setConnectivityStatus(
              effectiveType === "4g" ? "Stable Connection" : "Poor Connection"
            );
            setStatusIcon(<WifiIcon />);
          } else {
            setConnectivityStatus("Stable Connection");
            setStatusIcon(<WifiIcon />);
          }
          setNetworkSpeed(`${downlinkMbps.toFixed(2)} Mbps`);
        }
      } else {
        setConnectivityStatus("No Connection");
        setNetworkSpeed("0 Mbps");
        setStatusIcon(<WifiOffIcon color="action" />);
      }
    };

    // Initial update
    updateConnectivityStatus();

    // Add event listener for change in connection type
    window.addEventListener("online", updateConnectivityStatus);
    window.addEventListener("offline", updateConnectivityStatus);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("online", updateConnectivityStatus);
      window.removeEventListener("offline", updateConnectivityStatus);
    };
  }, [connectivityStatus]);

  return (
    <div
      className="conatiner"
      style={{
        width: " 300px",
        padding: "0",
        marginLeft: "auto",

        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "5px",
      }}
    >
      {connectivityStatus !== "Checking..." ? (
        <div
          className="status-container"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "10px",
            color: "white",
            fontWeight: "bold",
            padding: "5px",
          }}
        >
          <div>
            <p
              className="status"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                color: "white",
                fontWeight: "bold",
              }}
            >
              <span style={{ paddingTop: "7px" }}>{statusIcon} </span>{" "}
              {connectivityStatus}
            </p>
          </div>
          <div>
            <p className="speed" style={{ paddingTop: "7px" }}>
              {networkSpeed}
            </p>
          </div>
        </div>
      ) : (
        <p>Checking connectivity status...</p>
      )}
    </div>
  );
};
